import { createToken } from '@react-apps/core';
import type { ContentRepositoryImpl } from '../data/repositories/content.repository.impl';
import type { HarrisonRepositoryImpl } from '../data/repositories/harrison.repository.impl';

export const ContentRepositoryToken =
  createToken<ContentRepositoryImpl>('ContentRepository');

/** O Harrison: rascunho do comentário oficial e o prompt com que ele escreve. */
export const HarrisonRepositoryToken =
  createToken<HarrisonRepositoryImpl>('HarrisonRepository');
